module.exports = __webpack_public_path__ + "static/media/tickMark.7dd878d2.svg";